import React, { useState, useCallback } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import debounce from 'lodash.debounce';
import { useEffect } from 'react';

type Props = {
  label: string;
  value: string;
  onChange: Function;
  placeholder?: string;
};

export const InputSearch: React.FC<Props> = ({ value, label, onChange = () => {}, placeholder }) => {
  const [text, setText] = useState<string>(value);
  const onChangeHandler = useCallback(debounce(onChange, 10), []);

  const onTextChange = (value: string, event?: Event) => {
    setText(value);
    onChangeHandler(value);
    event?.stopPropagation();
  };

  const onClick = (event: Event) => {
    event.stopPropagation();
  };

  useEffect(() => {
    return () => {
      onTextChange('');
    };
  }, []);

  return <Input label={label} value={text} onChange={onTextChange} onClick={onClick} placeholder={placeholder} />;
};
